import { render, staticRenderFns } from "./RegistrationReviewForm.vue?vue&type=template&id=08e95cb7&scoped=true&"
import script from "./RegistrationReviewForm.vue?vue&type=script&lang=js&"
export * from "./RegistrationReviewForm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationReviewForm.vue?vue&type=style&index=0&id=08e95cb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e95cb7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VForm,VRow})
